<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">
  <div style="justify-content: center;align-self: center;margin-top: 2%;">
    <span style="font-size: 30px;">{{'Training Register' | translate | async}}</span>
  </div>

  <!-- manage_accounts -->
  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%; width: 90%;">
    <span class="material-icons" style="float: right; font-size: 27px; cursor: pointer;" (click)="NavigateToJobPositons()">manage_accounts</span>
    <div class="search-options"
         style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: 250px;">

      <mat-form-field class="header-form-full-width">


        <mat-placeholder>{{'All States' | translate | async}}</mat-placeholder>
        <mat-select (selectionChange)="SitesChanged($event)" [(ngModel)]="SelectdState" multiple ngDefaultControl>
          <mat-option *ngFor="let st of Sites" [value]="st.ID">
            {{st.SideCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-placeholder>{{'All Positions' | translate | async}}</mat-placeholder>
        <mat-select [(ngModel)]="SelectdPosition" ngDefaultControl multiple>
          <mat-option *ngFor="let position of jobPositionList" [value]="position.Id" (click)="FilterForms();FilterUsers();">
            {{position.positionName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>{{'All Forms' | translate | async}}</mat-label>
        <mat-select [(ngModel)]="SelectedForm" ngDefaultControl multiple>
          <mat-option *ngFor="let _type of FormList" [value]="_type.ID">
            {{_type.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>{{'All Users' | translate | async}}</mat-label>
        <mat-select [(ngModel)]="SelectedUser" ngDefaultControl multiple>
          <mat-option *ngFor="let _type of userList" [value]="_type.UserId">
            {{_type.FullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <div style="display: flex;flex-direction: row;min-width: 30%;height:40px; justify-content: space-around;">

        <section class="example-section">
          <mat-checkbox class="example-margin" [(ngModel)]="DateComplete" (change)="changeCheckbox('DateComplete')">{{'Date Completed' | translate | async}}</mat-checkbox>
          <mat-checkbox class="example-margin" [(ngModel)]="FollowUpDate" (change)="changeCheckbox('FollowUpDate')">{{'Follow Up Date' | translate | async}}</mat-checkbox>
        </section>
      </div>


      <div style="min-width: 30%;width: 30%;"></div>



      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <a class="button button__text" (click)="onResetClick()"><span class="button__text">{{'Reset' | translate | async}}</span></a>
        <button style="margin-left: 20px;" class="button button--primary" (click)="onSearch()" cdkFocusInitial>
          <span class="button__text">{{'Search' | translate | async}}</span>
        </button>
        <button *ngIf="ShowDownloadExcel" style="margin-left: 20px;" class="button button--primary" (click)="DownloadCSVFile()" cdkFocusInitial>
          <span class="button__text">{{'Export to Excel'| translate | async}}</span>
        </button>
      </div>

    </div>

  </mat-card>
  <div *ngIf="isLoading==true"><mat-spinner> </mat-spinner></div>
  <mat-card *ngIf="ShowTable" style="margin-top: 25px;margin-left: 2%;margin-right: 2%; width: 90%; overflow: auto;">
    <table class="table table--striped ng-star-inserted">
      <thead style="height: 60px;">
        <tr>

          <td style="padding: 5px 20px; text-align: left; font-weight: bold; color: #636363; width: 200px;">{{'Full Name' | translate | async}}</td>
          <td style="padding: 5px 20px;text-align: center; font-weight: bold;color: #636363;width: 100px;">USI</td>
          <ng-container *ngFor="let item of searchedFormList">
            <td style="padding: 5px 20px; text-align: center;font-weight: bold; width: 135px;color: #636363;">{{item.FormName}}</td>
          </ng-container>

        </tr>

      </thead>
      <tbody style="max-height: 500px; overflow-y: scroll; ">
        <ng-container *ngFor="let sr of searchUserList">
          <tr>
            <td style="text-align: left;"> {{sr.userName}}</td>
            <td style="text-align: center;"> {{sr.USI}}</td>

            <ng-container *ngFor="let form_ of searchedFormList">
              <td>
                <ng-container *ngFor="let form of searchedForm">
                  <ng-container *ngIf="sr.userID== form.reltedUserId && form_.FormId==form.fromID">
                    <ng-container *ngIf="form.followUpDate== null">


                      <span style="text-align: center;" *ngIf="IsdateCompleted && !IsfollowUpDate "> {{form.CompletedDate| date: 'dd-MMM-yyyy' }} </span>
                      <span style="text-align: center;" *ngIf="!IsdateCompleted && IsfollowUpDate "> {{form.followUpDate| date: 'dd-MMM-yyyy'}} </span>
                      <span style="text-align: center;" *ngIf="IsdateCompleted && IsfollowUpDate "> <span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span> <span>/{{form.followUpDate| date:  'dd-MMM-yyyy'}} </span> </span>


                    </ng-container>

                    <ng-container *ngIf="form.followUpDate!= null">
                      <ng-container *ngIf="form.IsExpired== true">
                        <span *ngIf="IsdateCompleted && !IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorExpired" style="width:25px">{{form.CompletedDate| date: 'dd-MMM-yyyy' }} </div>
                          </span>
                        </span>
                        <span *ngIf="!IsdateCompleted && IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorExpired" style="width:25px">{{form.followUpDate| date: 'dd-MMM-yyyy'}} </div>
                          </span>
                        </span>
                        <span *ngIf="IsdateCompleted && IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorExpired" style="width:25px"><span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span> <span> /{{form.followUpDate| date:  'dd-MMM-yyyy'}} </span>  </div>
                          </span>
                        </span>

                      </ng-container>

                      <ng-container *ngIf="form.IsExpired== false">
                        <span *ngIf="IsdateCompleted && !IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorNotExpired" style="width:25px">{{form.CompletedDate| date: 'dd-MMM-yyyy' }}</div>
                          </span>
                        </span>
                        <span *ngIf="!IsdateCompleted && IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorNotExpired" style="width:25px">{{form.followUpDate| date: 'dd-MMM-yyyy'}}</div>
                          </span>
                        </span>
                        <span *ngIf="IsdateCompleted && IsfollowUpDate ">
                          <span>
                            <div class="DateCell evalColorNotExpired" style="width:25px"><span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span><span>/{{form.followUpDate| date:  'dd-MMM-yyyy'}}</span> </div>
                          </span>
                        </span>
                      </ng-container>
                    </ng-container>

                  </ng-container>
                  <ng-container *ngIf="sr.userID!= form.reltedUserId">
                    <span>  </span>
                  </ng-container>

                </ng-container>
              </td>

            </ng-container>








            <!-- <ng-container *ngFor="let form of searchedForm">
                 <ng-container *ngFor="let form_ of searchedFormList">
                <ng-container *ngIf="form_.FormId==form.fromID">
                <ng-container  *ngIf="sr.userID== form.reltedUserId">
                  <ng-container  *ngIf="form.followUpDate== null">
                    <td style="text-align: center;" *ngIf="IsdateCompleted && !IsfollowUpDate "> {{form.CompletedDate| date: 'dd-MMM-yyyy' }} </td>
                    <td style="text-align: center;" *ngIf="!IsdateCompleted && IsfollowUpDate "> {{form.followUpDate| date: 'dd-MMM-yyyy'}} </td>
                    <td style="text-align: center;" *ngIf="IsdateCompleted && IsfollowUpDate "> <span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span> <span>/{{form.followUpDate| date:  'dd-MMM-yyyy'}} </span> </td>

                  </ng-container>
                  <ng-container  *ngIf="form.followUpDate!= null">
                    <ng-container  *ngIf="form.IsExpired== true">
                    <td  *ngIf="IsdateCompleted && !IsfollowUpDate ">
                     <span >
                        <div class="DateCell evalColorExpired"  style="width:25px">{{form.CompletedDate| date: 'dd-MMM-yyyy' }} </div>
                     </span>
                    </td>
                    <td  *ngIf="!IsdateCompleted && IsfollowUpDate ">
                      <span >
                        <div class="DateCell evalColorExpired" style="width:25px">{{form.followUpDate| date: 'dd-MMM-yyyy'}} </div>
                     </span>
                    </td>
                    <td  *ngIf="IsdateCompleted && IsfollowUpDate ">
                      <span >
                        <div class="DateCell evalColorExpired" style="width:25px"><span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span> <span> /{{form.followUpDate| date:  'dd-MMM-yyyy'}} </span>  </div>
                     </span>
                      </td>

                    </ng-container>

                    <ng-container  *ngIf="form.IsExpired== false">
                    <td  *ngIf="IsdateCompleted && !IsfollowUpDate ">
                      <span >
                        <div class="DateCell evalColorNotExpired" style="width:25px">{{form.CompletedDate| date: 'dd-MMM-yyyy' }}</div>
                     </span>
                    </td>
                    <td  *ngIf="!IsdateCompleted && IsfollowUpDate ">
                      <span >
                        <div class="DateCell evalColorNotExpired" style="width:25px">{{form.followUpDate| date: 'dd-MMM-yyyy'}}</div>
                     </span>
                    </td>
                    <td  *ngIf="IsdateCompleted && IsfollowUpDate ">
                      <span >
                        <div class="DateCell evalColorNotExpired" style="width:25px"><span>{{form.CompletedDate| date: 'dd-MMM-yyyy'}}</span><span>/{{form.followUpDate| date:  'dd-MMM-yyyy'}}</span> </div>
                     </span>
                    </td>
                    </ng-container>
                  </ng-container>
              </ng-container>
              <ng-container  *ngIf="sr.userID!= form.reltedUserId">
                <td>  </td>
              </ng-container>
            </ng-container>

          </ng-container>
          </ng-container>  -->


          </tr>

        </ng-container>
      </tbody>
    </table>
  </mat-card>
</div>
